import { DocType } from '@frontend/repository';
import React from 'react';
import { LuFile, LuX } from 'react-icons/lu';
import { FormattedMessage } from 'react-intl';

import useDropZone from './drop-zone.controller';

export interface DropZoneProps {
    dropZoneMessage?: React.ReactNode;
    enableImportButton?: boolean;
    importButtonLabel?: React.ReactNode;
    onChange: (file: File | null | undefined) => void;
    file: File | null | undefined;
    type?: DocType | DocType[] | string | string[];
    onUpload?: (file: File) => void;
}

export const DropZone = (props: DropZoneProps) => {
    const viewProps = useDropZone(props);
    if (props.file) {
        return (
            <div className='card card-body card-plain border-radius-lg flex w-full flex-row content-between items-center border'>
                <div className='flex content-start items-center'>
                    {props.file.type.includes('image') ? (
                        <img
                            src={URL.createObjectURL(props.file)}
                            alt='file'
                            className='img-fluid ms-2'
                            style={{ height: '300px' }}
                        />
                    ) : (
                        <div className='flex h-10 items-center justify-start gap-2'>
                            <LuFile />
                            <span className='font-weight-bolder'>{props.file.name}</span>
                        </div>
                    )}
                </div>

                <LuX
                    className='cursor-pointer'
                    onClick={() => props.onChange(undefined)}
                />
            </div>
        );
    }
    return (
        <div
            ref={viewProps.dropZoneRef}
            className={`height-200 border-secondary flex h-full w-full flex-col content-center items-center border border-dashed ${
                viewProps.isDropping ? 'bg-background-default' : ''
            }`}>
            <span className='font-weight-bolder'>
                {props.dropZoneMessage ? (
                    props.dropZoneMessage
                ) : (
                    <FormattedMessage
                        id='DropZone.DropZoneMessage'
                        description='Dropzone message'
                        defaultMessage='Drop a file here'
                    />
                )}
            </span>
            {props.enableImportButton && (
                <label
                    htmlFor='file-input'
                    className='btn btn-brand-primary'>
                    <input
                        type='file'
                        id='file-input'
                        className='hidden'
                        accept={viewProps.accept}
                        onChange={(e) => props.onChange(e.target.files?.[0])}
                    />
                    <span className='text-white'>{props.importButtonLabel}</span>
                </label>
            )}
            <div className='flex flex-col content-center text-center'>
                <span className='font-weight-bolder text-xs'>
                    <FormattedMessage
                        id='DropZone.AllowedTypes'
                        description='Label for the allowed file types'
                        defaultMessage='Allowed types'
                    />
                </span>
                <span className='text-xs'>{viewProps.allowedTypes}</span>
            </div>
            {viewProps.error && <div className='bg-danger fs-10 flex flex-row content-center rounded p-2 text-white'>{viewProps.error}</div>}
        </div>
    );
};
